import ManualDetectedTaskButton from './ManualDetectedTaskButton';
const AddTrackingCodeButton = ManualDetectedTaskButton;
export default AddTrackingCodeButton;